import { Component, input } from '@angular/core';
import { LvrDocumentItem } from '../../../../core/components/document-item/document-item';
import { CommonTemplate } from '../../../../api/api-types/document.api';
import { LvrRedirectNav } from '../../../../core/classes/redirect-nav.class';
import { toTemplateSlug } from '../../../../shared/helpers/to-template-slug.func';

@Component({
	selector: 'lvr-templates-list',
	imports: [LvrDocumentItem],
	templateUrl: './templates-list.html',
	styleUrl: './templates-list.scss',
})
export class TemplatesList extends LvrRedirectNav {
	public readonly templates = input.required<CommonTemplate[]>();

	public openTemplate(templateName: string) {
		const templateId = toTemplateSlug(templateName);
		this.navigateAfterFinished(['templates', templateId], { relativeTo: this.route });
	}
}
